export interface AddressData {
  street?: string;
  street1?: string;
  city?: string;
  stateCodeOrProvince?: string | null;
  zipcode?: string;
  country?: string;
}

export function formatAddress(address: AddressData): string {
  const { street, street1, city, stateCodeOrProvince, zipcode, country } = address;

  // Format city, state, and zipcode line
  const hasLocationData = city || stateCodeOrProvince || zipcode;
  const cityPart = city || "";
  const statePart = stateCodeOrProvince || "";
  const zipPart = zipcode || "";
  const separator = city && stateCodeOrProvince ? ", " : "";
  const locationLine = hasLocationData
    ? `${cityPart}${separator}${statePart} ${zipPart}`.trim()
    : null;

  const addressLines = [street, street1, locationLine, country].filter(Boolean);

  return addressLines.join("\n");
}
